import { findFreeName, isNameMatch } from './string.helpers';

const PROPOSAL_NAME_PREFIX = 'Proposal ';

/** Convert a zero-based index to spreadsheet-style letters: A..Z, AA..AZ, etc. */
const proposalNameSuffix = (index: number): string => {
  let remaining = index + 1;
  let suffix = '';

  while (remaining > 0) {
    remaining -= 1;
    suffix = String.fromCharCode(65 + (remaining % 26)) + suffix;
    remaining = Math.floor(remaining / 26);
  }

  return suffix;
};

/**
 * Returns the first free automatic proposal name in the A, B, ... Z, AA series.
 * Explicit/custom names continue to use the regular numeric de-duplication rule.
 */
export const getNextDefaultProposalName = (
  existingNames: readonly (string | undefined)[] = [],
): string => {
  for (let index = 0; ; index += 1) {
    const candidate = `${PROPOSAL_NAME_PREFIX}${proposalNameSuffix(index)}`;
    if (!existingNames.some((name) => isNameMatch(name, candidate))) {
      return candidate;
    }
  }
};

export const getUniqueProposalName = (
  existingNames: readonly (string | undefined)[],
  requestedName?: string,
): string =>
  requestedName === undefined || requestedName.trim() === ''
    ? getNextDefaultProposalName(existingNames)
    : findFreeName([...existingNames], requestedName);
